/*
 * Maison Forma – échantillons en rupture de stock, par gamme ou par coloris
 * Réglages lus sur la pochette « echantillons-tissu » (window.MF_ECH_RUPTURE, injecté par le snippet mf-echantillons-rupture) :
 *   gammes : gammes entières et/ou coloris précis, ex. « LUMA, SORA – Rouge Carmin » ; days : nombre de jours ouvrés (0 si mode texte) ; text : délai saisi
 * Fonctionne sur la page /pages/echantillons ([data-mfp]) et sur la fiche de la pochette ([data-mf-ech]) :
 *   - encart « Rupture de stock » dans chaque gamme concernée + étiquette sur son onglet ou sur le coloris ;
 *   - si le client choisit au moins un coloris en rupture : message près du bouton,
 *     propriété « Précommande » enregistrée dans la commande, ligne de livraison remplacée sur la fiche.
 */
(() => {
  if (window.__mfEchRupture) return;
  window.__mfEchRupture = true;

  const cfg = window.MF_ECH_RUPTURE;
  if (!cfg || !cfg.gammes) return;

  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();

  // Chaque entrée : une gamme entière (« LUMA ») ou un coloris précis (« LUMA – Rouge Carmin »)
  const wholeGammes = new Set();
  const colors = new Set();
  cfg.gammes.split(/[,;]/).forEach((entry) => {
    const parts = entry.split(/\s*[–—:-]\s*/).map((s) => s.trim()).filter(Boolean);
    if (parts.length === 1) wholeGammes.add(norm(parts[0]));
    else if (parts.length >= 2) colors.add(norm(parts[0]) + '|' + norm(parts.slice(1).join(' ')));
  });
  if (!wholeGammes.size && !colors.size) return;

  const splitValue = (v) => {
    const i = (v || '').indexOf(' – ');
    return i < 0 ? [v || '', ''] : [v.slice(0, i), v.slice(i + 3)];
  };
  const isWhole = (label) => wholeGammes.has(norm(label));
  const isColor = (g, c) => colors.has(norm(g) + '|' + norm(c));
  const valueInRupture = (v) => {
    const [g, c] = splitValue(v);
    return isWhole(g) || isColor(g, c);
  };

  const PROP_NAME = 'properties[Précommande]';

  function delay() {
    const P = window.MFPreorder;
    if (cfg.days > 0 && P) {
      const d = P.addBusinessDays(cfg.days);
      return { phrase: `livraison au plus tard le ${P.formatDate(d, false, true)}`, prop: `livraison au plus tard le ${P.formatDate(d, true)}` };
    }
    if (cfg.days > 0) {
      return { phrase: `livraison sous ${cfg.days} jours ouvrés`, prop: `livraison sous ${cfg.days} jours ouvrés` };
    }
    return { phrase: `livraison prévue ${cfg.text}`, prop: `livraison prévue ${cfg.text}` };
  }

  function injectStyles() {
    if (document.getElementById('mf-ech-rupture-css')) return;
    const st = document.createElement('style');
    st.id = 'mf-ech-rupture-css';
    st.textContent =
      '.mf-ech-rupture{margin:0 0 12px;padding:10px 12px;border-radius:10px;background:#FFF4E5;color:#7A4B00;font-size:.85rem;line-height:1.45}' +
      '.mf-ech-rupture b{font-weight:700}' +
      '.mf-ech-rupture--alert{margin:10px 0}' +
      '.mf-ech-rupture-tag{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:999px;background:#FFF4E5;color:#7A4B00;font-size:.7rem;font-weight:700;letter-spacing:.02em}' +
      '[aria-selected="true"] .mf-ech-rupture-tag{background:#fff}' +
      '.mf-ech-rupture-tag--opt{margin:2px 0 0;align-self:center}';
    document.head.appendChild(st);
  }

  function setup(root, kind) {
    if (root.dataset.mfRupture) return;
    root.dataset.mfRupture = '1';
    const d = delay();
    const fsSel = kind === 'page' ? 'fieldset[data-mfp-label]' : 'fieldset[data-mf-label]';
    const tabSel = kind === 'page' ? '.mfp-tab' : '.mf-ech__tab';
    const nameSel = kind === 'page' ? '.mfp-opt__name' : 'span';

    // 1) Gamme entière : encart + étiquette sur l'onglet. Coloris précis : étiquette sur le coloris + encart.
    root.querySelectorAll(fsSel).forEach((fs) => {
      const label = kind === 'page' ? fs.dataset.mfpLabel : fs.dataset.mfLabel;
      const legend = fs.querySelector('legend');
      const addNote = (html) => {
        const note = document.createElement('p');
        note.className = 'mf-ech-rupture';
        note.innerHTML = html;
        if (legend) legend.after(note); else fs.prepend(note);
      };

      if (isWhole(label)) {
        addNote('<b>Rupture de stock</b> sur les échantillons ' + label + ' · ' + d.phrase +
          '. Si vous choisissez un de ces coloris, votre pochette complète vous sera envoyée à cette date.');
        const key = kind === 'page' ? fs.dataset.mfpGamme : fs.dataset.mfGamme;
        root.querySelectorAll(tabSel).forEach((t) => {
          const tKey = kind === 'page' ? t.dataset.mfpGamme : t.dataset.mfGamme;
          if (tKey === key && !t.querySelector('.mf-ech-rupture-tag')) {
            const tag = document.createElement('span');
            tag.className = 'mf-ech-rupture-tag';
            tag.textContent = 'Rupture';
            t.firstChild ? t.firstChild.after(tag) : t.appendChild(tag);
          }
        });
        return;
      }

      const outColors = [];
      fs.querySelectorAll('input[type=checkbox]').forEach((box) => {
        const [g, c] = splitValue(box.value);
        if (!isColor(g, c)) return;
        outColors.push(c);
        const opt = box.closest('label');
        const nameEl = opt && (opt.querySelector(nameSel) || opt);
        if (nameEl && !opt.querySelector('.mf-ech-rupture-tag')) {
          const tag = document.createElement('span');
          tag.className = 'mf-ech-rupture-tag mf-ech-rupture-tag--opt';
          tag.textContent = 'Rupture';
          nameEl.after(tag);
        }
      });
      if (outColors.length) {
        addNote('<b>Rupture de stock</b> sur ' + (outColors.length > 1 ? 'les échantillons ' : "l'échantillon ") + outColors.join(', ') +
          ' · ' + d.phrase + '. Si vous ' + (outColors.length > 1 ? 'les' : 'le') + ' choisissez, votre pochette complète vous sera envoyée à cette date.');
      }
    });

    // 2) Formulaire d'ajout au panier
    const form = kind === 'page'
      ? root.querySelector('[data-mfp-form]')
      : root.closest('form') || document.querySelector('product-form form[action*="/cart/add"], main form[action*="/cart/add"]');
    if (!form) return;

    const alertEl = document.createElement('p');
    alertEl.className = 'mf-ech-rupture mf-ech-rupture--alert';
    alertEl.hidden = true;
    if (kind === 'page') {
      const anchor = form.querySelector('.mfp-cart__err') || form.querySelector('[data-mfp-btn]');
      anchor ? anchor.before(alertEl) : form.appendChild(alertEl);
    } else {
      const anchor = root.querySelector('.mf-ech__error') || root.lastElementChild;
      anchor ? anchor.before(alertEl) : root.appendChild(alertEl);
    }

    let setPreorderOnButton = false;

    function update() {
      const checked = [].slice.call(root.querySelectorAll('input[type=checkbox]:checked'));
      // Libellés en rupture parmi la sélection : « LUMA » pour une gamme entière, « LUMA Rouge Carmin » pour un coloris
      const hit = checked
        .filter((b) => valueInRupture(b.value))
        .map((b) => {
          const [g, c] = splitValue(b.value);
          return isWhole(g) ? g : g + ' ' + c;
        })
        .filter((x, i, a) => a.indexOf(x) === i);
      let input = form.querySelector(`input[name="${PROP_NAME}"][data-mf-ech-rupture]`);

      if (hit.length) {
        const dd = delay();
        const gam = hit.join(', ');
        alertEl.innerHTML = '<b>Échantillons ' + gam + ' en rupture de stock</b> : votre pochette vous sera envoyée en une fois, ' + dd.phrase + '.';
        alertEl.hidden = false;
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = PROP_NAME;
          input.dataset.mfEchRupture = '1';
          form.appendChild(input);
        }
        input.value = `Échantillons ${gam} en rupture de stock – ${dd.prop}`;
      } else {
        alertEl.hidden = true;
        if (input) input.remove();
      }

      // Fiche de la pochette : la ligne « Livraison estimée le … » suit la sélection
      if (kind === 'product') {
        const c = document.querySelector('[data-ref="add-to-cart-button-container"]');
        if (c) {
          if (hit.length) {
            c.dataset.preorder = 'true';
            if (cfg.days > 0) c.dataset.preorderDelayDays = String(cfg.days); else c.dataset.preorderDelayText = cfg.text;
            setPreorderOnButton = true;
          } else if (setPreorderOnButton) {
            delete c.dataset.preorder;
            delete c.dataset.preorderDelayDays;
            delete c.dataset.preorderDelayText;
            setPreorderOnButton = false;
          }
          if (window.MFPreorder && window.MFPreorder.syncEta) window.MFPreorder.syncEta();
        }
      }
    }

    root.addEventListener('change', update);
    // La page retire aussi des coloris via le bouton « × » du récapitulatif (sans événement change)
    root.addEventListener('click', () => setTimeout(update, 0));
    update();
  }

  function run() {
    injectStyles();
    document.querySelectorAll('[data-mfp]').forEach((r) => setup(r, 'page'));
    document.querySelectorAll('[data-mf-ech]').forEach((r) => setup(r, 'product'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
